@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 [appEditorId]="editorIds?.headline" kb-heading type="divider">
    {{attributes.headline}}
  </h2>
}

<kb-marquee [speed]=".5">
  @for (card of attributes.cards; track card; let i = $index) {
    <ng-container>
      @if (card.attributes.link){
        <a
          [kbRouterOrExternalLink]="card.attributes.link.attributes.url"
          [attr.target]="card.attributes.link.attributes.target"
          [appEditorId]="card.attributes.link.editorId"
          class="logo-link"
          draggable="false"
        >
          <ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{card: card}"></ng-container>
        </a>
      } @else {
        <div class="logo-link" draggable="false">
          <ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{card: card}"></ng-container>
        </div>
      }
    </ng-container>
  }
</kb-marquee>
<ng-template #cardTemplate let-card="card" [kbTemplateType]="cardTemplateType">
  @if (card.attributes.medium || card.attributes.text) {
    <section kb-card kb-color-variant="secondary-variant">
      <div slot="picture">
        <kb-picture
          [picture]="imageToPicture(card.attributes.logo.attributes, originalAspectRatio).sources"
          [alt]="card.attributes.logo.attributes.alt"
          [variants]="[{aspectRatio: originalAspectRatio}]"
          [draggable]="false"
          [rootColumns]="4"
          restrict-size="height"
        ></kb-picture>
      </div>
      @if (card.attributes.medium) {
        <kb-picture
          slot="title"
          [picture]="imageToPicture(card.attributes.medium.attributes, standardAspectRatio).sources"
          [alt]="card.attributes.medium.attributes.alt"
          [draggable]="false"
          [rootColumns]="4"
        ></kb-picture>
      }
      @if (card.attributes.text) {
        <div slot="content">
          <p kb-paragraph>{{ card.attributes.text }}</p>
          <div kb-standalone-link class="more-link">
            @if (card.attributes.linkText) {
              {{ card.attributes.linkText }}
            } @else {
              <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
            }
          </div>
        </div>
      }
    </section>
  } @else {
    <kb-picture
      class="standalone-logo"
      restrict-size="height"
      [picture]="imageToPicture(card.attributes.logo.attributes, originalAspectRatio).sources"
      [alt]="card.attributes.logo.attributes.alt"
      [variants]="[{aspectRatio: originalAspectRatio}]"
      [draggable]="false"
      [rootColumns]="4"
    ></kb-picture>
  }
</ng-template>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
